module.exports = __webpack_public_path__ + "static/media/aniversario-yellow-icon.117944ed.svg";